import { render, staticRenderFns } from "./CrudHealthRegion-comp.vue?vue&type=template&id=64b7a666&scoped=true&"
import script from "./CrudHealthRegion-comp.vue?vue&type=script&lang=js&"
export * from "./CrudHealthRegion-comp.vue?vue&type=script&lang=js&"
import style0 from "./CrudHealthRegion-comp.vue?vue&type=style&index=0&id=64b7a666&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7a666",
  null
  
)

export default component.exports